module.exports = __webpack_public_path__ + "static/media/no-results-0088c48c.png";